<div class="login-container" *ngIf="!isDialogOpen">
  <div class="login-card">
    <h3 class="mat-h3 mat-typography">Welcome to Evidant DTR</h3>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="login-field">
        <input
          type="text"
          formControlName="username"
          placeholder="Username"
        />
        <mat-error *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
          Username is required
        </mat-error>
      </div>
      <div class="login-field password-container">
        <input
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Password"
        />
        <i
          class="eye-icon"
          (click)="togglePasswordVisibility()"
          [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'">
        </i>
        <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          Password is required
        </mat-error>
      </div>
    <!--  <div class="login-field">
        <mat-form-field appearance="fill" class="full-width wider-select">
          <mat-label>Organization</mat-label>
          <mat-select formControlName="organization">
            <mat-option *ngFor="let org of organizations" [value]="org.id">
              {{ org.organizationName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="loginForm.get('organization')?.invalid && loginForm.get('organization')?.touched">
            Organization is required
          </mat-error>
        </mat-form-field>
      </div>-->
      
      <button type="submit" class="login-btn" [disabled]="loginForm.invalid">
        <span *ngIf="loading">Signing in...</span>
        <span *ngIf="!loading">Sign In</span>
      </button>
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      <a class="forgot-password" routerLink="/forgot-password">Forgot Password?</a>
    </form>
  </div>
</div>
